import { AppointmentStatus } from '../domain/types';

export const appointmentStatusLabels: {
  [key in AppointmentStatus]: string
} = {
  TODO: 'Da fare',
  CANCELLED: 'Annullato',
  DONE: 'Fatto',
};
